module.exports = __webpack_public_path__ + "media/500HzSawtooth.81f648c9.wav";